import React ,{useState} from 'react';
import { useNavigate } from 'react-router';
import { 
        EuiButtonEmpty,
        EuiFlyoutBody,
        EuiFlyoutHeader,
        EuiButton,
        EuiText,
        EuiSpacer,
        EuiTitle,
        EuiFlyoutFooter,
        EuiDragDropContext,
        EuiDraggable,
        EuiDroppable,
        EuiPanel,
        EuiIcon,
        euiDragDropReorder,
        EuiFlexGroup,
        EuiFlexItem,
        copyToClipboard,
        EuiModal ,
        EuiModalHeader,
        EuiModalBody,
        EuiModalHeaderTitle,
        EuiHeader,
        EuiHeaderSection,
        EuiHeaderSectionItem,
        EuiModalFooter } from '@elastic/eui';
import {TranslateLanguage} from '../components/KeywordTranslator';        
import '../style.css';
import logosmall from '../assets/CTBLogoCircle-Small.png';
import LoadUserSettings, {RemoveShareListItem, SaveUserSettings, SaveShareListItem} from '../components/UserServices';
import TopRightMenu from "../components/TopRightMenu"; 
import LanguageToggle from "../components/LanguageToggle";
import Footer from '../components/Footer';


function ShareList(props){
    const navigate = useNavigate();
    var language = localStorage.userLanguage;
    // var videoJson = '[{"id": "i2", "playListId": "1", "title": "活出愛", "itemId": "lfP-3JLVvaw","itemType" : "v", "docType" : "詩歌" }]'
    var videoJson = '[{"id": "ctb-worship-tc|3101", "playListId": "1", "title": "活出愛", "videoId": "lfP-3JLVvaw","itemType" : "v", "docType" : "詩歌" }]'
    // var videoIdList =  (LoadUserSettings("","shareItemList", true)) ? LoadUserSettings("","shareItemList", true) : JSON.parse(videoJson);
    var videoIdList = LoadUserSettings("", "shareItemList", true);
    const [list, setList] = useState(videoIdList);
    const currentURL = window.location.origin;
    const divStyle = { "text-align": "center" };
    const [shareLink, setSharelink] = useState("");
    const [isModalVisible, setisModalVisible] = useState(false);

    if (!videoIdList) {
      // 沒有資料 → 儲存預設 videoJson
      SaveShareListItem("",1,"ctb-worship-tc|3101", "https://www.youtube.com/watch?v=lfP-3JLVvaw" , "活出愛", "v", "詩歌" );
      // 再用預設資料
      videoIdList = JSON.parse(videoJson);
    }
    
    const opts = {
        width:"",
        height: "",
        playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1 
        }
    };    

    const previewShare = ()=> {
      var items = "";
      list.forEach((element, index) => {
        items += element.id +",";
      })
      items = window.location.origin + "/share?items=" + btoa(items.substring(0,items.length-1));
      window.location = items;
    }
    
    const shareClicked = ()=> {
      var items = "";
      list.forEach((element, index) => {
        items += element.id +",";
      })
      items = window.location.origin + "/share?items=" + btoa(items.substring(0,items.length-1));
      setSharelink(items);
      setisModalVisible(true);
    }

    const closeModal =()=> {
      copyToClipboard(shareLink);
      setisModalVisible(false);
    }

    let modal;
    if (isModalVisible) {
      modal = (
        <EuiModal onClose={closeModal}>
          <EuiModalHeader>
            <EuiModalHeaderTitle>
              <h2> {TranslateLanguage(language, "分享我的收藏")}</h2>
            </EuiModalHeaderTitle>
          </EuiModalHeader>
  
          <EuiModalBody>
          {TranslateLanguage(language, "您可以使用以下的連結來分享您的收藏。")}
            <EuiSpacer />{shareLink}
          </EuiModalBody>
  
          <EuiModalFooter>
            <EuiButton onClick={closeModal} fill>
            {TranslateLanguage(language, "複製 Copy Link")}
            </EuiButton>
          </EuiModalFooter>
        </EuiModal>
      );
    }

    const onDragEnd = ({ source, destination }) => {
    if (source && destination) {
        const items = euiDragDropReorder(list, source.index, destination.index);
        setList(items);
        SaveUserSettings("","shareItemList",items, true);
    }
    };

    const onRemoveItem = (index) => {
    var newList = RemoveShareListItem("", 1, index);
    setList(newList);
    }

    return (
        <>
        <div className="appHeaderSticky">
          <EuiHeader className="no-shadow-header">
              <EuiHeaderSection>
              {/* 左侧：Logo / 搜索等 */}
              </EuiHeaderSection>
              <EuiHeaderSection side="right">
              {/* 右侧：你的按钮 */}
              {/* 新增首页按钮 */}
              <EuiHeaderSectionItem>
                  <EuiButtonEmpty
                      size="s"
                      iconType="home"
                      onClick={() => (window.location.href = currentURL)}  // ✅ 点击返回起始页
                      color="text"
                      iconSide="left"
                      style={{
                      fontWeight: 500,
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      height: '32px',
                      padding: '0 8px',
                      }}
                  >
                  {TranslateLanguage(localStorage.userLanguage, "首頁")}
                  </EuiButtonEmpty>
              </EuiHeaderSectionItem>
              <EuiHeaderSectionItem>
                  <LanguageToggle />
              </EuiHeaderSectionItem>
              <EuiHeaderSectionItem>
                  <TopRightMenu withLanguage="1" />
              </EuiHeaderSectionItem>
              </EuiHeaderSection>
          </EuiHeader>
      </div>
        {modal}
        <EuiFlyoutHeader hasBorder>
        <div  style={{"text-align": "center"}}>
          <span><a href={currentURL}><img  src={logosmall} alt="Check The Bible" /></a> </span>
              <EuiTitle size="m"><h2 id="mysharelist">{TranslateLanguage(language, "我的收藏")}</h2></EuiTitle>
        </div>
        </EuiFlyoutHeader>
        <EuiFlyoutBody>
            <EuiText size="s">{TranslateLanguage(language, "您可以使用下面項目中 ")}<EuiIcon type="grab"></EuiIcon>{TranslateLanguage(language, " 圖示拖拉收藏項目來重新排序，或使用 X 圖示來移除。目前最多只能存取不重複15個項目")}</EuiText>
            <EuiSpacer></EuiSpacer>
            <EuiDragDropContext onDragEnd={onDragEnd} >
              <EuiDroppable droppableId="DROPPABLE_AREA" spacing="none">
                {list.map(({ videoId, title, id, docType }, idx) => (
                  <EuiDraggable spacing="none" key={id} index={idx} draggableId={id} hasBorder={true} >
                    {(provided, state) => (
                      <EuiPanel hasShadow={state.isDragging} hasBorder={true} paddingSize="none"  style={{"margin": "6px", "border":"1px solid #D3DAE6"}}>
                        <EuiFlexGroup responsive={false}>
                          <EuiFlexItem grow={false}  style={{"width": "8px"}}>
                            <EuiIcon type="grab" style={{"margin": "8px"}}/>
                          </EuiFlexItem>
                          <EuiFlexItem grow={false}  >
                            <EuiButtonEmpty  iconType="cross" onClick={()=> onRemoveItem(idx)} ></EuiButtonEmpty>
                          </EuiFlexItem>
                          <EuiFlexItem ><EuiText>
                          {TranslateLanguage(language, docType+" : ")}
                          {TranslateLanguage(language, 
                                                title.replace(/[!^0-9a-z-A-Z()（）/? ]/g, "").replace(/ +/, " ") != "" ? 
                                                title.replace(/[!^0-9a-z-A-Z()（）/? ]/g, "").replace(/ +/, " ").substring(0,50) : title)}
                          {title.replace(/[!^0-9a-z-A-Z()（）/? ]/g, "").replace(/ +/, " ").length > 50 ? "..." : ""}
                          </EuiText>
                          </EuiFlexItem>
                        </EuiFlexGroup>
                      </EuiPanel>
                    )}
                  </EuiDraggable>
                ))}
              </EuiDroppable>
            </EuiDragDropContext>
        </EuiFlyoutBody>
        <EuiFlyoutFooter>
          <EuiFlexGroup gutterSize="m">
            <EuiFlexItem grow={false}><EuiButton onClick={() => previewShare()}>{TranslateLanguage(language, "預覽")}</EuiButton></EuiFlexItem>
            <EuiFlexItem grow={false}><EuiButton size="m" color="primary" fill onClick={() => shareClicked()}>{TranslateLanguage(language, "分享給好友")}</EuiButton></EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlyoutFooter>
        {/* <Footer /> */}
      </>
  )
}

export default ShareList